import React, {Component} from 'react';
import PredicateItem from "./PredicateItem";
import {connect} from "react-redux";
import PredicateGroup from "./PredicateGroup";
import defaultPredicateOption from './const/defaultPredicateOption'
import defaultSwitchPredicateOption from './const/switch/defaultSwitchPredicateOption';

import axios from "axios";
import axiosConfig from "../../../../utils/axiosConfig";
import messageCodes from "../../../../utils/messageCodes";
import {showToastForBackend, showToastForFrontend} from "../../../../actions/toastActions";
import {
    PredicateAlwaysTrueCheckbox
} from "../InputPortListUtils/components/PredicateAlwaysTrueCheckbox";

class Predicate extends Component {
    constructor(props) {
        super(props);

        let initialPredicate = this.props.predicate;
        if (Array.isArray(initialPredicate.predicates)) {
            initialPredicate.predicates = initialPredicate.predicates.map((p, index) => ({
                ...p,
                id: index + 1
            }));
        }
        this.state = {
            predicate: initialPredicate,
            predicateBlockType: this.props.predicateBlockType,
            itemProperties: this.props.itemProperties,
            userProperties: this.props.userProperties ? this.props.userProperties : []
        };

        this.onPredicateOptionUpdate = this.onPredicateOptionUpdate.bind(this);
        this.toggleAndOr = this.toggleAndOr.bind(this);
        this.onClickAddNewButton = this.onClickAddNewButton.bind(this);
        this.onClickNew = this.onClickNew.bind(this);

        this.defaultPredicateOption = props.predicateBlockType === "switch" ? defaultSwitchPredicateOption : defaultPredicateOption
    }

    componentDidMount() {
        const itemProperties = this.state.itemProperties,
            userProperties = this.state.userProperties;
        if (itemProperties.length === 0) {
            axios.get(this.props.properties.databaseUrl + "/properties/items", axiosConfig())
                .then(response => {
                    this.setState({
                        itemProperties: response.data.sort()
                    });
                })
                .catch(err => {
                    if (err.response)
                        this.props.showToastForBackend(err.response.data);
                    else
                        this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                });
        }

        if (userProperties.length === 0) {
            axios.get(this.props.properties.databaseUrl + "/properties/users", axiosConfig())
                .then(response => {
                    this.setState({
                        userProperties: response.data.sort()
                    });
                })
                .catch(err => {
                    if (err.response)
                        this.props.showToastForBackend(err.response.data);
                    else
                        this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                });
        }
    }

    onPredicateOptionUpdate(index, predicateData) {
        this.setState(prevState => {
        let predicate = { ...prevState.predicate };
        predicate.predicates[index] = { ...predicateData, id: predicate.predicates[index].id };
        return { predicate };
        }, () => {this.updatePredicate(this.state.predicate);});


    }

    onPredicateDelete(index) {
        let predicate = {...this.state.predicate};
        predicate.predicates = predicate.predicates.filter((value, predicateIndex) => predicateIndex !== index);

        this.updatePredicate(predicate);
    }

    toggleAndOr() {
        const type = this.state.predicate.type === "and" ? "or" : "and";

        this.updatePredicate({
            ...this.state.predicate,
            type,
        });
    }

    onClickAddNewButton() {
        this.setState(prevState => ({
            showAddNew: !prevState.showAddNew
        }));
    }

    onClickAlwaysTrue(e) {
        const value = e.target.checked;
        this.setState(prevState => {
            const predicate = {...prevState.predicate};
            if (value === true) {
                predicate.predicates[0].type = "trueValue";
            } else {
                predicate.predicates[0].prevType = predicate.predicates[0].prevType !== undefined  ? predicate.predicates[0].prevType : "comparison";
                predicate.predicates[0].type = predicate.predicates[0].prevType
            }

            predicate.alwaysTrue = value;

            return {
                ...prevState,
                predicate: predicate
            };
        }, () => {
            this.updatePredicate({...this.state.predicate});
        });
    }

    onClickNew(isCondition) {
        let newCondition;
        let nextPredicateId = 1;

        if (this.state.predicate.predicates.length > 0) {
                const maxId = Math.max(...this.state.predicate.predicates.map(p => p.id));
                nextPredicateId = maxId + 1;
            }

        if (isCondition) {
            newCondition = this.props.defaultPredicateValue ? { ...this.props.defaultPredicateValue, id: nextPredicateId } : { ...this.defaultPredicateOption, id: nextPredicateId };
        } else {
            newCondition = {
                type: "and",
                predicates: [],
                id: nextPredicateId};
            }

       this.setState(prevState => ({
            predicate: {
                ...prevState.predicate,
                predicates: [...prevState.predicate.predicates, newCondition]
            },
            showAddNew: false
        }), () => {
            this.updatePredicate({ ...this.state.predicate });
        });
    }

    isGroup(predicate) {
        return predicate.type === "and" || predicate.type === "or";
    }

    updatePredicate(predicate) {
        this.setState({
            predicate: predicate
        }, () => {
            this.props.updateOptions(this.state.predicate);});
    }

    render() {
        return (
            <div className="predicate-panel">
                <div className="predicate-group-header-wrapper predicate-disabled">
                    <div className={"predicate-group-header " + (this.state.predicate.alwaysTrue !== undefined ? "always-true-header " : "")}>
                        <div className="predicate-label-group">
                            <div
                                className={"label" + (this.state.predicate.type === "and" ? " and-label" : " or-label") + (this.state.predicate.alwaysTrue ? " predicate-disabled" : "")}
                                onClick={this.toggleAndOr}>{(this.state.predicate.type === "and" ? "AND" : "OR")}
                            </div>
                            <div className={"label" + (this.state.predicate.alwaysTrue ? " predicate-disabled" : "")}
                                 onClick={this.toggleAndOr}>{(this.state.predicate.type === "and" ? "OR" : "AND")}
                            </div>
                        </div>
                        <div className="predicate-always-true-container">
                            {
                                this.state.predicate.alwaysTrue !== undefined &&
                                <PredicateAlwaysTrueCheckbox isChecked={this.state.predicate.alwaysTrue}
                                                             onCheck={(e) => this.onClickAlwaysTrue(e)}/>
                            }
                        </div>
                    </div>
                    <div className={"main-and predicate-group " + this.state.predicate.type + (this.state.predicate.alwaysTrue ? " predicate-disabled" : "")}>
                        {this.state.predicate.predicates.map((predicate, index) => {
                            if (this.isGroup(predicate)) {
                                return <PredicateGroup key={predicate.id}
                                                       disableArea={this.state.predicate.alwaysTrue ?? this.props.disableArea}
                                                       defaultPredicateValue={this.props.defaultPredicateValue}
                                                       userProperties={this.state.userProperties}
                                                       itemProperties={this.state.itemProperties}
                                                       contextProperties={this.props.contextProps}
                                                       predicateBlockType={this.state.predicateBlockType}
                                                       predicate={predicate}
                                                       onPredicateOptionUpdate={(data => this.onPredicateOptionUpdate(index, data))}
                                                       onPredicateDelete={() => this.onPredicateDelete(index)}/>
                            } else {
                                return (
                                    <PredicateItem key={predicate.id}
                                                   {...predicate}
                                                   index={predicate.id}
                                                   userProperties={this.state.userProperties}
                                                   itemProperties={this.state.itemProperties}
                                                   disableArea={this.state.predicate.alwaysTrue ?? this.props.disableArea}
                                                   contextProperties={this.props.contextProps}
                                                   predicateBlockType={this.state.predicateBlockType}
                                                   onPredicateOptionUpdate={(data) => this.onPredicateOptionUpdate(index, data)}
                                                   onPredicateDelete={() => this.onPredicateDelete(index)}
                                                   hasInputCount={this.props.hasInputCount}/>)
                            }
                        })}
                    </div>
                    <div className={"add-new-options" + (this.state.predicate.alwaysTrue ? " predicate-disabled" : "")}>
                        <button onClick={this.onClickAddNewButton}
                                className={"add-new-button " + this.state.predicate.type + (this.state.predicate.alwaysTrue ? " predicate-disabled" : "")}><span>+</span>
                        </button>
                        <div onClick={() => this.onClickNew(true)}
                             className={"new " + (this.state.showAddNew ? "active" : "") + (this.state.predicate.alwaysTrue ? " predicate-disabled" : "")}>
                            New Condition
                        </div>
                        <div onClick={() => this.onClickNew(false)}
                             className={"new " + (this.state.showAddNew ? "active" : "") + (this.state.predicate.alwaysTrue ? " predicate-disabled" : "")}>
                            New Group
                        </div>
                    </div>
                </div>
            </div>
        )
            ;
    }
}

function mapStateToProps(state) {
    return {
        properties: state.properties,
        contextProps: state.contextProperties,
        itemProperties: state.itemProperties,
        userProperties: state.userProperties
    }
}

export default connect(mapStateToProps, {showToastForFrontend, showToastForBackend})(Predicate);
